'use client';

import {
  enablePostNewsletterAtom,
  postNewsletterDescriptionAtom,
  postNewsletterTitleAtom,
} from 'app/blog/[domain]/_components/design-state';
import {
  NewsletterForm,
  type NewsletterFormProps,
} from 'app/blog/[domain]/(standalone)/_components/newsletter-form';
import { useAtomValue } from 'jotai';

export function PostNewsletter(
  props: Omit<NewsletterFormProps, 'title' | 'description'>,
) {
  const enablePostNewsletter = useAtomValue(enablePostNewsletterAtom);
  const postNewsletterTitle = useAtomValue(postNewsletterTitleAtom);
  const postNewsletterDescription = useAtomValue(postNewsletterDescriptionAtom);
  if (!enablePostNewsletter) {
    return <></>;
  }
  return (
    <NewsletterForm
      {...props}
      title={postNewsletterTitle}
      description={postNewsletterDescription}
      className="post-newsletter"
    />
  );
}
